import { api } from '@/lib/api'
import type { RebalanceResponse } from '@/types/rebalance'

export async function getRebalanceView(params?: {
  cashInput?: number | null
}): Promise<RebalanceResponse> {
  const queryParams: Record<string, string> = {}
  if (params?.cashInput !== undefined && params?.cashInput !== null) {
    queryParams.cash_input = String(params.cashInput)
  }
  const { data } = await api.get<RebalanceResponse>('/rebalance/', { params: queryParams })
  return data
}
